import { Component, OnInit } from '@angular/core';
import { ModalComponent } from '../../../../../vass-core/components/modal/modal.component';

@Component({
  selector: 'app-modal-error-tpv',
  templateUrl: './modal-error-tpv.component.html',
  styleUrls: ['./modal-error-tpv.component.scss'],
  standalone: false,
})
export class ModalErrorTpvComponent implements OnInit {
  constructor(private modalComponent: ModalComponent) {}

  ngOnInit() {}

  accept() {
    this.modalComponent.accept();
  }
}
